import React from 'react';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
// import Translation from '../translation/translation';

function ImageLightBoxHeader({ title }) {
    return (
        <div className="image-light-box__header image-light-box-header" dangerouslySetInnerHTML={toDangerousReactHtml(title)}>
        </div>
    );
}

export { ImageLightBoxHeader };
